<template>
    <window-portal :open="dataProps.show" @close="dataProps.show = false">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center><div><p style="font-size: 30px;">Vista previa de impresión de Reporte de Estado de Resultados</p></div></center>
            <br/>
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="Print()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
                
            </center>
            <center><div v-if="loading"><p>Cargando...</p></div></center>

        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>

        <div class="book" style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
                <div style="margin: 0 auto; width: 1000px;">
                    <div ref="dataprint" style="margin: 0 !important; padding: 0 !important;">
                        <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
                        <div v-for="( page , indexPage) in pages" :key="indexPage" style="position: relative; width: 1000px; min-height: 1293px; background: white;">
                            <hr/>
                            <div class="subpage" style="height: 1250px; padding-top: 20px; overflow: hidden;">
                                <div style="margin-left: 80px; margin-right: 50px;">
                                    <div style="text-align: center; font-size: 12px;">
                                        <h2>{{ businessName }}</h2>
                                        <p>{{ dataProps.balanceHeader }}.</p>
                                        <p>{{ getcurrency }}</p>
                                    </div>
                                    
                                    <br/>
                                    <!-- Heres is the body -->
                                    <div v-if="page.operationalIncomes.values.length > 0" style="width: 100%;">
                                        <table style="width: 100% !important; margin-bottom: 22px; font-size: 12px; border-collapse: collapse;">
                                            <thead style="text-align: center; width: 100%;">
                                                <tr>
                                                    <th></th>
                                                    <th style="text-align: left;">
                                                        INGRESOS OPERACIONALES
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tbody>
                                                <tr v-for="(item, indexActivo) in page.operationalIncomes.values" :key="indexActivo">
                                                    <td :style="`padding: 2px; width: 10%;`">{{ item["account_code"] }}</td>
                                                    <td :style="`padding: 2px; width: 30%;`">{{ item["account_description"] }}</td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['SubAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["SubAccountsBalance"] ? numberWithCommas(item["SubAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['MajorAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["MajorAccountsBalance"] ? numberWithCommas(item["MajorAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['IsFirst']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["IsFirst"] ? numberWithCommas( item["HeaderAccountsBalance"] ) : '' }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tfoot v-if="page.operationalIncomes?.isLastPage">
                                                <tr>
                                                    <th colspan="4" style="text-align: right; padding-right: 30px;">TOTAL</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right; border-top: double; border-bottom: double;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ getTotal( 'operationalIncomes' ).replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div v-if="page.costsReturnsAndSales.values.length > 0" style="width: 100%;">
                                        <table style="width: 100% !important; margin-bottom: 22px; font-size: 12px; border-collapse: collapse;">
                                            <thead style="text-align: center; width: 100%;">
                                                <tr>
                                                    <th></th>
                                                    <th style="text-align: left;">
                                                        COSTOS, REBAJAS Y DEVOLUCIONES 
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tbody>
                                                <tr v-for="(item, indexActivo) in page.costsReturnsAndSales.values" :key="indexActivo">
                                                    <td :style="`padding: 2px; width: 10%;`">{{ item["account_code"] }}</td>
                                                    <td colspan="" :style="`padding: 2px; width: 30%;`">{{ item["account_description"] }}</td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['SubAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["SubAccountsBalance"] ? numberWithCommas(item["SubAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['MajorAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["MajorAccountsBalance"] ? numberWithCommas(item["MajorAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['IsFirst']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["IsFirst"] ? numberWithCommas( item["HeaderAccountsBalance"] ) : '' }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tfoot v-if="page.costsReturnsAndSales?.isLastPage">
                                                <tr>
                                                    <th colspan="4" style="text-align: right; padding-right: 30px;">TOTAL</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right; border-top: double; border-bottom: double;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ getTotal( 'costsReturnsAndSales' ).replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th colspan="4" style="text-align: right; padding-right: 30px;">UTILIDAD BRUTA:</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right; border-bottom: 1px solid;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ `${ numberWithCommas( utilidadBruta ) }` }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div v-if="page.operationalSpents.values.length > 0" style="width: 100%;">
                                        <table style="width: 100% !important; margin-bottom: 22px; font-size: 12px; border-collapse: collapse;">
                                            <thead style="text-align: center; width: 100%;">
                                                <tr>
                                                    <th></th>
                                                    <th style="text-align: left;">
                                                        GASTOS DE OPERACIÓN
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tbody>
                                                <tr v-for="(item, indexActivo) in page.operationalSpents.values" :key="indexActivo">
                                                    <td :style="`padding: 2px; width: 10%;`">{{ item["account_code"] }}</td>
                                                    <td :style="`padding: 2px; width: 30%;`">{{ item["account_description"] }}</td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['SubAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["SubAccountsBalance"] ? numberWithCommas(item["SubAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['MajorAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["MajorAccountsBalance"] ? numberWithCommas(item["MajorAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['IsFirst']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["IsFirst"] ? numberWithCommas( item["HeaderAccountsBalance"] ) : '' }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tfoot v-if="page.operationalSpents?.isLastPage">
                                                <tr>
                                                    <th colspan="4" style="text-align: right; padding-right: 30px;">TOTAL</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right; border-top: double; border-bottom: double;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ getTotal( 'operationalSpents' ).replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div v-if="page.nonOperationalSpents.values.length > 0" style="width: 100%;">
                                        <table style="width: 100% !important; margin-bottom: 22px; font-size: 12px; border-collapse: collapse;">
                                            <thead style="text-align: center; width: 100%;">
                                                <tr>
                                                    <th></th>
                                                    <th style="text-align: left;">
                                                        OTROS GASTOS NO OPERACIONALES
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tbody>
                                                <tr v-for="(item, indexActivo) in page.nonOperationalSpents.values" :key="indexActivo">
                                                    <td :style="`padding: 2px; width: 10%;`">{{ item["account_code"] }}</td>
                                                    <td :style="`padding: 2px; width: 30%;`">{{ item["account_description"] }}</td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['SubAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["SubAccountsBalance"] ? numberWithCommas(item["SubAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['MajorAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["MajorAccountsBalance"] ? numberWithCommas(item["MajorAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['IsFirst']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["IsFirst"] ? numberWithCommas( item["HeaderAccountsBalance"] ) : '' }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tfoot v-if="page.nonOperationalSpents?.isLastPage">
                                                <tr>
                                                    <th colspan="4" style="text-align: right; padding-right: 30px;">TOTAL</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right; border-top: double; border-bottom: double;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ getTotal( 'nonOperationalSpents' ).replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div v-if="( page?.nonOperationalSpents && page?.nonOperationalSpents?.isLastPage ) || ( !page?.nonOperationalSpents && page?.operationalSpents && page?.operationalSpents?.isLastPage )">
                                        <table style="width: 100% !important; margin-bottom: 22px; font-size: 12px; border-collapse: collapse;">
                                            <tfoot>
                                                <tr>
                                                    <th colspan="4" style="text-align: right; padding-right: 30px;">UTILIDAD DE OPERACIÓN:</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right; border-bottom: 1px solid;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ `${ numberWithCommas( utilidadDeOperacion ) }` }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div v-if="page.anotherNonOperationalIncomes.values.length > 0" style="width: 100%;">
                                        <table style="width: 100% !important; margin-bottom: 22px; font-size: 12px; border-collapse: collapse;">
                                            <thead style="text-align: center; width: 100%;">
                                                <tr>
                                                    <th></th>
                                                    <th style="text-align: left;">
                                                        OTROS INGRESOS NO OPERACIONALES
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tbody>
                                                <tr v-for="(item, indexActivo) in page.anotherNonOperationalIncomes.values" :key="indexActivo">
                                                    <td :style="`padding: 2px; width: 10%;`">{{ item["account_code"] }}</td>
                                                    <td :style="`padding: 2px; width: 30%;`">{{ item["account_description"] }}</td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['SubAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["SubAccountsBalance"] ? numberWithCommas(item["SubAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['MajorAccountsBalance']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["MajorAccountsBalance"] ? numberWithCommas(item["MajorAccountsBalance"]) : '' }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span v-if="item['IsFirst']">{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["IsFirst"] ? numberWithCommas( item["HeaderAccountsBalance"] ) : '' }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <hr size="8" color="transparent" style="border: 0;">
                                            <tfoot v-if="page.anotherNonOperationalIncomes?.isLastPage">
                                                <tr>
                                                    <th colspan="4" style="text-align: right; padding-right: 30px;">TOTAL</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right; border-top: double; border-bottom: double;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ getTotal( 'anotherNonOperationalIncomes' ).replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th colspan="4" style="text-align: right; padding-right: 30px;">UTILIDAD ANTES DE IMPUESTOS Y RESERVA:</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right; border-bottom: 1px solid;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ `${ numberWithCommas( utilidadAntesDeImpuestosYReserva ) }` }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div v-if="closingTheBooks && page.anotherNonOperationalIncomes?.isLastPage" style="width: 100%;">
                                        <table style="width: 100% !important; margin-bottom: 22px; font-size: 12px; border-collapse: collapse;">
                                            <tfoot>
                                                <tr>
                                                    <th colspan="4" style="text-align: left; padding-right: 30px;">RESERVA LEGAL</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ `${ numberWithCommas( totalLegalReserve ) }` }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th colspan="4" style="text-align: right; padding-right: 30px;">UTILIDAD ANTES DE IMPUESTOS:</th>
                                                    <td style="padding: 2px; width: 20%; text-align: right; border-bottom: 1px solid;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ `${ numberWithCommas( utilidadAntesDeImpuestos ) }` }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <table v-if="indexPage === pages.length - 1" style="width: 100% !important; margin-bottom: 22px; font-size: 12px; border-collapse: collapse;">
                                        <tfoot>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <th style="text-align: right; padding-right: 30px;">IMPUESTOS SOBRE LA RENTA:</th>
                                                <td style="padding: 2px; width: 20%; text-align: right; border-bottom: 1px solid;">
                                                    <div style="display: flex; justify-content: space-between; width: 100%;">
                                                        <span>{{`${ currencySymbol } `}}</span>
                                                        <span style="word-wrap: anywhere;">{{ `${ numberWithCommas( impuestosSobreLaRenta ) }` }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <th style="text-align: right; padding-right: 30px;">UTILIDAD NETA:</th>
                                                <td style="padding: 2px; width: 20%; text-align: right; border-bottom: 1px solid;">
                                                    <div style="display: flex; justify-content: space-between; width: 100%;">
                                                        <span>{{`${ currencySymbol } `}}</span>
                                                        <span style="word-wrap: anywhere;">{{ `${ numberWithCommas( utilidadNeta ) }` }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                    <div v-if="indexPage === pages.length - 1" style="width: 100%; margin-top: 150px;">
                                        <table style="width: 100%">
                                            <tr style="width: 100%">
                                                <td style="width: 33.33%" >
                                                    <div style="border-bottom: 0.5px solid; width: 80%; margin: auto;">
                                                        
                                                    </div>
                                                </td>
                                                <td style="width: 33.33%" >
                                                    <div style="border-bottom: 0.5px solid; width: 80%; margin: auto;">
                                                        
                                                    </div>
                                                </td>
                                                <td style="width: 33.33%" >
                                                    <div style="border-bottom: 0.5px solid; width: 80%; margin: auto;">
                                                        
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style="width: 100%;">
                                                <td style="width: 33.33%" >
                                                    <div style="width: 80%; margin: auto; text-align: center; font-size: 12.5px;">
                                                        {{ LegalRepresentativeName ?? 'Representante Legal' }}
                                                    </div>
                                                    <div style="width: 80%; margin: auto; text-align: center; font-size: 12.5px;">
                                                        {{ LegalRepresentativeAdditional ?? '' }}
                                                    </div>
                                                    <div style="width: 80%; margin: auto; text-align: center; font-size: 12.5px;">
                                                        {{ `${LegalRepresentativeName ? 'Representante Legal' : ''}` }}
                                                    </div>
                                                </td>
                                                <td style="width: 33.33%" >
                                                    <div style="width: 80%; margin: auto; text-align: center; font-size: 12.5px">
                                                        {{ AuditorName ?? 'Auditor' }}
                                                    </div>
                                                    <div style="width: 80%; margin: auto; text-align: center; font-size: 12.5px">
                                                        {{ AuditorAdditional ?? '' }}
                                                    </div>
                                                    <div style="width: 80%; margin: auto; text-align: center; font-size: 12.5px">
                                                        {{ `${AuditorName ? 'Auditor' : ''}` }}
                                                    </div>
                                                </td>
                                                <td style="width: 33.33%" >
                                                    <div style="width: 80%; margin: auto; text-align: center; font-size: 12.5px;">
                                                        {{ AccountantName  ?? 'Contador' }}
                                                    </div>
                                                    <div style="width: 80%; margin: auto; text-align: center; font-size: 12.5px;">
                                                        {{ AccountantAdditional ?? '' }}
                                                    </div>
                                                    <div style="width: 80%; margin: auto; text-align: center; font-size: 12.5px;">
                                                        {{ `${AccountantName ? 'Contador' : ''}` }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                
                                <div style="position: absolute; bottom: 0; width: 100%; left: 80px">
                                    <p style="font-size:10px;">Pagina {{ indexPage+1 }} de {{ pages.length }}</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
//import QRCode from 'qrcode';
//import html2canvas from "html2canvas"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc"
import { numberWithCommas } from "../../helpers/money";
import {numberToText} from '@/helpers/conveterNumberText.js'
import { calcOptimalTotalOnColumns } from "../../helpers/array";

export default {
    name: "PrintResultsStatementsReport",
    props: ['dataProps' ],
    components: {WindowPortal},
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            //seal: "",
            //sealBranch: "",
            pages: [],
            //valuesRows: []
            mailLabel: null,
            valuesRows: [],
            urlQr: null,
            typePrint: 0,
            consolidateValues: {},
            borderTp: 0,
            rowsNumberPerReport: 53,
            businessName: JSON.parse( localStorage.getItem( 'user' ) ).business,
            currencySymbol: JSON.parse( localStorage.getItem( 'branch' ) ).Currency,
            LegalRepresentativeName: JSON.parse(localStorage.getItem("user")).LegalRepresentativeName,
            LegalRepresentativeAdditional: JSON.parse(localStorage.getItem("user")).LegalRepresentativeAdditional,
            AccountantName: JSON.parse(localStorage.getItem("user")).AccountantName,
            AccountantAdditional: JSON.parse(localStorage.getItem("user")).AccountantAdditional,
            AuditorName: JSON.parse(localStorage.getItem("user")).AuditorName,
            AuditorAdditional: JSON.parse(localStorage.getItem("user")).AuditorAdditional,
        }
    },
    mounted() {
        this.calculatePagesOfDoc()
        this.getHeaderFooter()
    },
    computed: {
        
        closingTheBooks() {
            return this.dataProps.data.monthOfRequest === '12';
        },
        utilidadBruta() {
            return this.getTotal( 'operationalIncomes', true ) - this.getTotal( 'costsReturnsAndSales', true );
        },
        utilidadDeOperacion() {
            return this.utilidadBruta - this.getTotal( 'operationalSpents', true ) - this.getTotal( 'nonOperationalSpents', true );
        },
        utilidadAntesDeImpuestosYReserva() {
            return this.utilidadDeOperacion + this.getTotal( 'anotherNonOperationalIncomes', true );
        },
        totalLegalReserve() {
            const maxLegalReserve = this.getTotal( 'socialCapital', true ) * 0.20;
            const totalLegalReserveStoraged = this.getTotal( 'legalReserve', true );

            let legalReserve = 0.00;

            if( !this.dataProps.data.notToCalculateLegalReserve ) {
                if( totalLegalReserveStoraged < maxLegalReserve ) {
                    if( this.utilidadAntesDeImpuestosYReserva > 0 ) {
                        const sevenPercentOfUtilidadAntesDeImpuestosYReserva = this.utilidadAntesDeImpuestosYReserva * 0.07;
        
                        const storagePlusSevenPercent = totalLegalReserveStoraged + sevenPercentOfUtilidadAntesDeImpuestosYReserva;
        
                        if( storagePlusSevenPercent < maxLegalReserve ) {
                            legalReserve = sevenPercentOfUtilidadAntesDeImpuestosYReserva;
                        } else {
                            const excessOfSevenPercent = storagePlusSevenPercent - maxLegalReserve;
        
                            const newLegalReserv = sevenPercentOfUtilidadAntesDeImpuestosYReserva - excessOfSevenPercent;
        
                            if( newLegalReserv > 0 ) {
                                legalReserve = newLegalReserv;
                            }
                        }
                    }
                }
            } else {
                legalReserve = totalLegalReserveStoraged;
            }

            return legalReserve;
        },
        utilidadAntesDeImpuestos() {
            return this.utilidadAntesDeImpuestosYReserva - ( this.closingTheBooks ? this.totalLegalReserve : 0 );
        },
        impuestosSobreLaRenta() {
            const totalOperacionalFormated = this.getTotal('operationalIncomes');
            const totalOperacional = parseFloat(totalOperacionalFormated.replace(/[^0-9.]/g, ''))
            return this.closingTheBooks
                ? this.utilidadAntesDeImpuestos < 0
                    ? 0
                    : totalOperacional < 150000
                        ? this.utilidadAntesDeImpuestos * 0.25
                        : this.utilidadAntesDeImpuestos * 0.30
                : 0 ;
        },
        utilidadNeta() {
            return this.utilidadAntesDeImpuestos - this.impuestosSobreLaRenta;
        },
        getBalanceIntegerType() {
            return {
                'por Rubro': 1,
                'por Cuentas de Mayor': 2,
                'por Subcuentas': 3
            }
        },
        getBigColumnWidth(){
            const balanceType = this.getBalanceIntegerType[ this.dataProps.balanceType ];

            const widthDictionary = [
                80,
                60,
                40
            ]
            
            return widthDictionary[ balanceType - 1 ];
        },
        getTotalColspan() {
            const balanceType = this.getBalanceIntegerType[ this.dataProps.balanceType ];

            const colspanDictionary = [
                1,
                2,
                3
            ]

            return colspanDictionary[ balanceType - 1 ];
        },
        getcurrency() {
            const countries = this.$store.getters.getCountries;
            const currency = countries.find( current => current.currency_symbol === this.currencySymbol );

            return currency.currency_name.toUpperCase();
        },
        BillingNrc() {
            return addFormatNRC(this.dataProps.data.branch.BusinessBillingNRC)
        },
        BillingNit() {
            //consog.log(this.dataProps.data.branch.BusinessBillingNIT);
            return addFormatToNIT(this.dataProps.data.branch.BusinessBillingNIT)
        }
    },
    watch: {
        'dataProps.show'() {
            if(this.dataProps.show){
                setTimeout(async () => {
                    await this.calculatePagesOfDoc()
                }, 0);
            }
        },
        'dataProps'() {
            this.calculatePagesOfDoc()
        }
    },
    methods: {
        // colspanReturning( index, order ) {
        //     if( index = )
        // },
        getTotalBySubAccountsBalance( recordType ) {
            const { data: { records } } = this.dataProps;
            let total = 0.00
            
            total = calcOptimalTotalOnColumns( records[ recordType ], [ 'MajorAccountsBalance', 'HeaderAccountsBalance' ] )
            
            return total;
        },
        getTotal( recordType, forCalc = false ) {
            const { data: { records } } = this.dataProps;
            let total = 0.00;

            for( const element of records[ recordType ] ) {
                if( element?.IsFirst === 1 ) {
                    total += element.CurrentBalance ? element.CurrentBalance : 0;
                }
            }

            return forCalc === true ? total : `${ this.currencySymbol }${ numberWithCommas( total ) }`;
        },
        GetnumberToText(number) {
            if(number) return numberToText(number)
            else return ''
        },
        numberWithCommas(x) {
            return numberWithCommas(x);
        },
        getHeaderFooter() {
            let search = {};
            search.ID_business = JSON.parse(localStorage.getItem("user")).businessid || ""
            search.ID_branch = JSON.parse(localStorage.getItem("user")).branch || ""
            this.$API.HF.getHF(search).then((data) => {
                let header = [], footer = [];
                header = data.filter((x) => x.State == '1' && x.Type == 'Header');
                this.header = header.length > 0 ? JSON.parse(header[0].Body).html : '';
                this.header = this.header.replace(/(\n)/gm, "");
                footer = data.filter((x) => x.State == '1' && x.Type == 'Footer');
                this.footer = footer.length > 0 ? JSON.parse(footer[0].Body).html : '';
            })
        },
        calculatePagesOfDoc() {
            try{
                this.pages = [];
                const { data: { records } } = this.dataProps;

                this.typePrint = 0;
                let currentPage = 0;
                let currentRowsPerPage = 0;

                this.pages[ currentPage ] = {
                    operationalIncomes: {
                        values: [],
                        isLastPage: false
                    },
                    costsReturnsAndSales: {
                        values: [],
                        isLastPage: false
                    },
                    operationalSpents: {
                        values: [],
                        isLastPage: false
                    },
                    nonOperationalSpents: {
                        values: [],
                        isLastPage: false
                    },
                    anotherNonOperationalIncomes: {
                        values: [],
                        isLastPage: false
                    },
                    legalReserve: {
                        values: [],
                        isLastPage: false
                    },
                    socialCapital: {
                        values: [],
                        isLastPage: false
                    },
                    isLastPage: false
                };

                for( const key in records ) {
                    for( const i in records[ key ] ) {
                        const element = records[ key ][ i ];
    
                        if( currentRowsPerPage <= this.rowsNumberPerReport ) {
                            currentRowsPerPage ++;
                            if( i == records[ key ].length - 1 ) {
                                this.pages[ currentPage ][ key ].isLastPage = true;
                                currentRowsPerPage += 3; // extra rows for summary
                            }
                            if( i == records[ key ].length - 1 && key === 'anotherNonOperationalIncomes' ) {
                                this.pages[ currentPage ][ key ].values.push( element );
                                this.pages[ currentPage ].isLastPage = true;
                                currentRowsPerPage += 3; // extra rows for summary
                            } else {
                                this.pages[ currentPage ][ key ].values.push( element );
                            }
                        } else {
                            currentPage ++;
                            currentRowsPerPage = 0;
                            this.pages[ currentPage ] = {
                                operationalIncomes: {
                                    values: [],
                                    isLastPage: false
                                },
                                costsReturnsAndSales: {
                                    values: [],
                                    isLastPage: false
                                },
                                operationalSpents: {
                                    values: [],
                                    isLastPage: false
                                },
                                nonOperationalSpents: {
                                    values: [],
                                    isLastPage: false
                                },
                                anotherNonOperationalIncomes: {
                                    values: [],
                                    isLastPage: false
                                },
                                legalReserve: {
                                    values: [],
                                    isLastPage: false
                                },
                                socialCapital: {
                                    values: [],
                                    isLastPage: false
                                },
                                isLastPage: false
                            };

                            this.pages[ currentPage ][ key ].values.push( element )
                        }
                    }
                }

                // let lengthOfLastPage = 0;
                // for( const element in this.pages[ this.pages.length - 1] ) {
                //     if( element != 'isLastPage' ) {
                //         lengthOfLastPage += this.pages[ this.pages.length - 1][ element ]?.values.length;
                //     }
                // }

                if( currentRowsPerPage > this.rowsNumberPerReport - 10 ) {
                    currentPage ++;
                    currentRowsPerPage = 0;
                    this.pages[ currentPage ] = {
                        operationalIncomes: {
                            values: [],
                            isLastPage: false
                        },
                        costsReturnsAndSales: {
                            values: [],
                            isLastPage: false
                        },
                        operationalSpents: {
                            values: [],
                            isLastPage: false
                        },
                        nonOperationalSpents: {
                            values: [],
                            isLastPage: false
                        },
                        anotherNonOperationalIncomes: {
                            values: [],
                            isLastPage: false
                        },
                        legalReserve: {
                            values: [],
                            isLastPage: false
                        },
                        socialCapital: {
                            values: [],
                            isLastPage: false
                        },
                        isLastPage: false
                    };
                }
            }
            catch(err) {
                console.log( err );
                // alert(err)
            }
        },

        async Print(){
            this.loading = true;
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            })
            
            
            //doc.deletePage(2)

            doc.autoPrint({variant: 'non-conform'});
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },

        async Download(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });
            
            //doc.deletePage(2)
            doc.save(`Reporte de estado de resultados - ${ this.businessName } - ${ this.dataProps.balanceHeader }.pdf`); //Agregado por Juan 13082023

            this.loading = false
        },
        async sendMail() {
            try {
                this.mailLabel = null;
                var doc = new jsPDF('p', 'pt', 'letter')
                //console.log(doc);
                //console.log(this.$refs.dataprint);
                await doc.html(this.$refs.dataprint, {
                    callback: function(doc){
                        doc.output()
                    },
                    x: 0,
                    y: 0,
                    margin: [0, 0, 0, 0],
                    html2canvas:{ 
                        scale: 0.612,
                        //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                        useCORS: true,
                        logging: false,
                        allowTaint: true
                    },
                });
                
                const body = {
                    dtefilebuffer: new Buffer.from(doc.output('arraybuffer')),
                    dtejson: this.dataProps.data.dteJson,
                    dtefilebufferfilename: this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".pdf"
                };

                // console.log(body);
                this.$API.invoices.sendInvoiceMail(body);

                this.mailLabel = 'Se envió el correo correctamente';
                this.$emit('mailSent');
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al enviar el correo';
                console.log(error);
            }
        },
        async downLoadJSON() {
            try {
                const aElement = document.createElement('a');
                aElement.setAttribute('download', this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".pdf");
                const blob = new Blob([JSON.stringify(this.dataProps.data.dteJson)], { type: 'application/json' });
                const href = URL.createObjectURL(blob);
                aElement.href = href;
                aElement.download = this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".json";
                aElement.click();
                URL.revokeObjectURL(href);
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al enviar el correo';
                console.log(error);
            }
        }
    }
}
</script>

<style scoped>

    .u-row .u-col-100{
        width: 100% !important;
    }
    .btnclean{
        border-radius: 15px;
        border: 1px solid white;
        background-color: #F29D35 !important;
        color: white !important;
    }

    * {
        font-family: Arial, Helvetica, sans-serif !important;
    }

</style>
